export default {
  'CHANGE_SKUS' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_SKUS' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/skus/mutations.js